export const comments_5588477 = {"data":{"data":[],"links":{}}}